module.exports = __webpack_public_path__ + "static/media/screenshot(35).c4109c93.jpg";